import { Injectable } from '@angular/core';
import {PrefixGroupsApiService} from '../prefix-groups/prefix-groups-api.service';
import {AttributesApiService} from '../../../users/attributes/attributes-api.service';
import {NodeApiService} from '../../../network/online/node/node-api.service';
import {NumberPortabilityApiService} from '../number-portability/number-portability-api.service';
import {GroupsApiService} from '../../../users/groups/groups-api.service';
import * as _ from 'lodash';
import {AttributeManipulationGroupsApiService} from '../attribute-manipulation-groups/attribute-manipulation-groups-api.service';
import {PeerConnectionApiService} from '../../../peer-connection/peer-connection-api.service';
import {ResourceGroupApiService} from '../../../../../network/services/online/resource-group/resource-group-api.service';
import {SipManipulationGroupApiService} from '../sip-manipulation-groups/sip-manipulation-group-api.service';
import {SipConditionGroupApiService} from '../sip-condition-group/sip-condition-group-api.service';

@Injectable({
  providedIn: 'root'
})
export class ComplementaryDataApiService {

  constructor(private prefixGroupsApiService: PrefixGroupsApiService,
              private attributesApi2Service: AttributesApiService,
              private peerConnectionsApiService: PeerConnectionApiService,
              private nodesApiService: NodeApiService,
              private numberPortabilityApiService: NumberPortabilityApiService,
              private resourceGroupsApiService: ResourceGroupApiService,
              private groupsApi2Service: GroupsApiService,
              private normalizationGroupApiService: AttributeManipulationGroupsApiService,
              private sipConditionGroupApiService: SipConditionGroupApiService,
              private sipManipulationGroupApiService: SipManipulationGroupApiService) {
  }

  public getExternalData(): Promise<any> {
    return Promise.all([
      this.prefixGroupsApiService.getPrefixGroupsSlim().toPromise(),
      this.attributesApi2Service.getAttributes(),
      this.nodesApiService.getNodes(),
      this.peerConnectionsApiService.getPCons(),
      this.numberPortabilityApiService.getNumberPortabilityImplementations().toPromise(),
      this.resourceGroupsApiService.getGroups(),
      this.groupsApi2Service.getGroups(),
      this.normalizationGroupApiService.getAttributeManipulationGroups().toPromise(),
      this.sipConditionGroupApiService.getSipConditionGroups().toPromise(),
      this.sipManipulationGroupApiService.getSipManipulationGroups().toPromise()
    ]).then(data => {
      return {
        prefixGroups: data[0].elements,
        attributes: this.sortAttributes(data[1]),
        nodes: data[2],
        pCons: data[3].elements,
        numberPortability: data[4],
        resourceGroups: data[5].elements.filter(item => item.type !== 'VOIP_PEER'),
        userGroups: data[6],
        normalizationGroups: data[7],
        sipConditionGroups: data[8],
        sipManipulationGroups: data[9]
      };
    });
  }

  private sortAttributes(attributes): any {
    return _.sortBy(attributes, o => {
      return o.name.toLowerCase();
    });
  }
}
